<template>
  <div class="product-detail-product">
    <p class="is-size-3 text-center mb-5 mt-2 product-detail-product-title">
      {{ productTree.product_detail.withtax_price.amount / 100 }}
      {{ productTree.product_detail.withtax_price.currency.symbol }}
    </p>
    <p class="text-center pb-2 mb-2">
      {{ productTree.name }}
    </p>
    <product-cart-btn
      :product-id="productTree.product_detail.id"
      v-if="addToCartBtn"
    />
  </div>
</template>

<script>
import VueI18n from "vue-i18n";
import { LocaleMixin } from "@/mixins/LocaleMixin";
import ProductCartBtn from "@/components/ProductCartBtn.vue";

export default {
  name: "ProductDetailProduct",
  components: { ProductCartBtn },
  mixins: [LocaleMixin],
  props: {
    productTree: Object,
    addToCartBtn: {
      type: Boolean,
      default: true
    }
  },

  // Translate component
  mounted() {
    this.$i18n.locale = this.getLocale();
  },
  i18n: new VueI18n({
    locale: "fr",
    messages: {
      en: {
        for_n_tickets: "per entry | for %{count} entries"
      },
      fr: {
        for_n_tickets: "l'entrée | les %{count} entrées"
      }
    }
  })
}
</script>
<style lang="scss">
  .product-detail-product {
    .product-detail-product-title {
      line-height: 1em;
    }
  }
</style>
